import React from "react";

const PlayerDragCard = ({ player, teamIndex, isSelected, onClick }) => {
  const handleDragStart = (e) => {
    e.dataTransfer.setData(
      "application/json",
      JSON.stringify({
        playerId: player.id,
        fromTeamIndex: teamIndex,
      }),
    );
    e.dataTransfer.effectAllowed = "move";
  };

  const getScoreColor = (score) => {
    if (!score && score !== 0) return "bg-gray-100 text-gray-500";
    if (score >= 4) return "bg-green-100 text-green-700";
    if (score >= 3) return "bg-yellow-100 text-yellow-700";
    return "bg-red-100 text-red-700";
  };

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className={`flex items-center justify-between px-2 py-1.5 rounded border cursor-move transition-all ${
        isSelected
          ? "border-slate-500 bg-slate-50 ring-2 ring-slate-200"
          : "border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50"
      }`}
    >
      <div className="flex items-center gap-2 min-w-0">
        {/* Drag handle indicator */}
        <div className="flex flex-col gap-0.5">
          <div className="w-1 h-1 rounded-full bg-gray-300"></div>
          <div className="w-1 h-1 rounded-full bg-gray-300"></div>
          <div className="w-1 h-1 rounded-full bg-gray-300"></div>
        </div>

        {/* Player info */}
        <div className="min-w-0">
          <p className="text-sm font-medium text-gray-900 truncate">
            {player.name}
          </p>
          <div className="flex items-center gap-2 text-xs text-gray-500">
            {player.number && <span>#{player.number}</span>}
            {player.position && <span>{player.position}</span>}
            {player.group && (
              <span className="px-1 bg-gray-100 rounded">{player.group}</span>
            )}
          </div>
        </div>
      </div>

      {/* Score */}
      <div
        className={`px-2 py-0.5 rounded text-xs font-medium ${getScoreColor(
          player.average_score,
        )}`}
      >
        {player.average_score !== null && player.average_score !== undefined
          ? player.average_score.toFixed(1)
          : "—"}
      </div>
    </div>
  );
};

export { PlayerDragCard };
